import axiosInstance from "./api/axiosInstance";
import { RegistrationDto } from "./types/registration";

export const submitRegistration = async (data: RegistrationDto) => {
  const response = await axiosInstance.post("/marketing/registration", data);
  return response.data;
};